import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';
import { NavConfig } from '../../data/constants/nav';

const R4CommScreenDisplay = lazy(
  () => import('../r4draft/R4CommScreenDisplay')
);
const R4LiveDraft = lazy(() => import('../r4draft/R4LiveDraft'));

const R5PlayerDisplay = lazy(() => import('../r5draft/R5PlayerDisplay'));
const R5LiveDraft = lazy(() => import('../r5draft/R5LiveDraft'));

const FileViewer = lazy(() => import('../common/ScreenshotFileViewer'));

export default [
  {
    path: '/file-viewer',
    element: (
      <Suspense>
        <FileViewer />
      </Suspense>
    ),
  },
  {
    id: NavConfig.linkConfigs.R4_COMM_SCREEN_DISPLAY.id,
    path: NavConfig.linkConfigs.R4_COMM_SCREEN_DISPLAY.to,
    element: (
      <R4LiveDraft>
        <Suspense>
          <Outlet />
          <R4CommScreenDisplay />
        </Suspense>
      </R4LiveDraft>
    ),
  },
  {
    id: NavConfig.linkConfigs.R5_PLAYER_DISPLAY.id,
    path: NavConfig.linkConfigs.R5_PLAYER_DISPLAY.to,
    element: (
      <R5LiveDraft>
        <Suspense>
          <Outlet />
          <R5PlayerDisplay />
        </Suspense>
      </R5LiveDraft>
    ),
  },
];
